import Cookies from 'js-cookie';
import './Questionary.scss';

export default () => {
  const questionary = document.querySelector('.Questionary');
  const notification = document.querySelector('[data-questionary="notification"]');
  if (!questionary || !notification) return;
  const ignoreButton = notification.querySelector('[data-questionary="action-ignore"]');
  const answerButton = notification.querySelector('[data-questionary="action-answer"]');

  const cookieQuestionary = 'questionary';
  const questionaryState = Cookies.get(cookieQuestionary);

  const show = () => {
    questionary.classList.add('-show');
    notification.classList.add('-show');
  };

  const hide = () => {
    Cookies.set(cookieQuestionary, 'ignore', { expires: 30 }); // set cookie for 1 months
    questionary.classList.remove('-show');
    notification.classList.remove('-show');
  };

  if (questionaryState !== 'ignore') show();

  ignoreButton.addEventListener('click', () => {
    hide();
  });

  answerButton.addEventListener('click', () => {
    window.open('https://am4rudlpsi6.typeform.com/to/fbSWaow8');
    hide();
  });
};
